const mEditionProductTrackingCodesModalDelete = {
  mEditionProductTrackingCodesModalDelete: {
    alerts: {
      deleteProductoCodigoRastreo: {
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.',
        success: 'El código de rastreo se eliminó exitosamente.'
      }
    },

    buttonCancel: 'CANCELAR',
    buttonPrimary: 'ELIMINAR',

    messageDelete: {
      element: 'Se eliminará código de rastreo',
      options: 'y todas sus características de forma definitiva.',
      notReversed: 'Esta acción no podrá ser revertida.'
    },

    title: 'Eliminar Código'
  }
}

export default mEditionProductTrackingCodesModalDelete
